if($("cus_email").val() == undefined) {
  IsCartPage = "true";
}
var nowAllowCloths = 0;
var nowAllowAccessories = 0;
$(document).ready(function(){
      var pageURL = $(location).attr("href");
      pageURL =  pageURL.split("#");
      pageURL =  pageURL[0].split("/");
      cart_page = pageURL[pageURL.length-1];
      console.log("cart_page : "+cart_page);
      if(cart_page == "cart"){
        $(document).on("click",".fancybox-close",function(e) {
          if($('#complete_profile_popup_web:visible').length > 0 || $('#complete_profile_popup_mob:visible').length > 0 ){
              if($("cus_email").val() == undefined) {
                localStorage.setItem("step2close", "1");
              }
          }
        });
        $(document).on("keyup","body",function(e) {
            if($('#complete_profile_popup_web:visible').length > 0 || $('#complete_profile_popup_mob:visible').length > 0 ){
              if(e.key === "Escape"){
                if($("cus_email").val() == undefined) {
                  localStorage.setItem("step2close", "1");
                }
              }
            }
        });
      }
})
function proceedToCheckout(){
  if ($("#cus_email").val() != undefined) {
    $("#proceed_checkout_loading_image,#proceed_checkout_loading_image-1").show();
    proceed_to_checkout_loading_img();
    setTimeout(function() {
      var cart = get_cart_Shopify();
      var sku_presence = found_sku(cart);
      if (sku_presence == true) {
        localStorage.setItem('noOtr',undefined);
        if(window.location.href.indexOf('otr') == -1 ){
          localStorage.setItem('noOtr','1');
          //$('#fedexmodal').modal('show');
        }
        var cart_items = [];
        for(var i = 0;i<cart.items.length;i++){
          if(cart.items[i].properties.item_type != "SaleItem"){
            cart_items.push(cart.items[i]);
          }
        }
          CheckCustomerPlan(cart_items);
          localStorage.removeItem("step2close");
          localStorage.removeItem("cartisgo");
      }
      else {
        // SKU Missing in some items
        $(".proceed_btn_generic_error").html("Please remove invalid items: <br/>" + sku_presence);
        $(".proceed_btn_generic_error").show();
        proceed_to_checkout_loading_img();
      }
    },3000);
  }
  else{
    localStorage.setItem('cartisgo',1);
  }
}
if(localStorage.getItem('cartisgo') == '1') {
    debugger;
    setTimeout(function(){
      if(localStorage.getItem('step2close') == '1'){
        proceedToCheckout();
        localStorage.removeItem("step2close");
      }
    },1000);
}
function proceed_to_checkout_loading_img() {
  if($(".proceed-to-checkout").val() == "Proceed to checkout") {
    $(".proceed-to-checkout").val("");
    $('.proceed-to-checkout').prop('disabled', true);
    $("#proceed_checkout_loading_image,#proceed_checkout_loading_image-1").show();
  }
  else {
    $(".proceed-to-checkout").val('Proceed to checkout');
    $('.proceed-to-checkout').prop('disabled', false);
    $("#proceed_checkout_loading_image,#proceed_checkout_loading_image-1").hide();
  }
}

function less_clothing_items_popup() {
  var email = $("#cus_email").val();
  var customer = GetCustomer(email);
  var subs = customer.data[0].subscriptions
  var customer_subscription =  subs.data[0].plan.id;

  var total_products_in_cart        =  $(".item_tags");
  var membership_products_in_cart   =  $(".membership_items_table .item_tags");
  var total_no_of_accessories       =  0;
  var total_no_of_clothes           =  0;
  var no_of_membership_clothes      =  0;
  var no_of_membership_accessories  =  0;
  var customer_subscription         =  subs.data[0].plan.id;
  var plan_name                     =  subs.data[0].plan.name;
  var page_redirection              =  true;

  plan_name = get_plan_name(plan_name);

  if(total_products_in_cart.length > 0)
  { 
    for (var i = 0; i < membership_products_in_cart.length; i++) 
    {
      if($(membership_products_in_cart[i]).val().toLowerCase().includes("clothing"))
      {
        no_of_membership_clothes++;
      }

      if($(membership_products_in_cart[i]).val().toLowerCase().includes("accessor"))
      {
        no_of_membership_accessories++;
      }
    }

    for (var i = 0; i < total_products_in_cart.length; i++) 
    {
      if($(total_products_in_cart[i]).val().toLowerCase().includes("clothing"))
      {
        total_no_of_clothes++;
      }

      if($(total_products_in_cart[i]).val().toLowerCase().includes("accessor"))
      {
        total_no_of_accessories++;
      }
    }
  }

  if (ALLOWED_PRODUCTS[subs.data[0].plan.id]["accessories"] > no_of_membership_accessories) {
    // Only Accessories are less. Clothing are taken as per user plan
    var less_accessory_items_count = (ALLOWED_PRODUCTS[customer_subscription]["accessories"] - no_of_membership_accessories);
    var accessory_grammar = null;

    if (less_accessory_items_count == 1)
    {
      accessory_grammar = "With the " + plan_name + " plan you are allowed to get <span style='color:#f69295'>" + less_accessory_items_count + " more accessory item</span>. <br> Are you sure you want to checkout without an extra free accessory item?";
    }
    else if (less_accessory_items_count > 1)
    {
      accessory_grammar = "With the " + plan_name + " plan you are allowed to get <span style='color:#f69295'>" + less_accessory_items_count + " more accessory items</span>. <br> Are you sure you want to checkout without extra free accessory items?";
    }

    $(".less_item_message").html(accessory_grammar);
    $("a#less_accessory_items_in_cart_trigger").click();
  }

  else
  {
    window.location.href = STORE_URL + "/pages/checkout";
  }
}

function check_customer_tags_for_FP() {
  var customer = get_specifc_customers_Shopify($('#customer').val());
  // console.log("CUSTOMER TAGS (h.1.0):");
  // console.log(customer.customers[0].tags);

  if(customer.customers[0].tags.includes("CurrentlyBorrowing")) {
    $(".fp_error").text("We must receive your current items back before you can check out new FashionPass items").show();
    return true
  }
  else if(customer.customers[0].tags.includes("Paused")) {
    $(".fp_error").text("You cannot check out FashionPass items because your FashionPass subscription is paused.").show();
    return true;
  }
  else {
    $(".fp_error").text("");
    return false;
  }
}
function differenceBetween2Num(num1, num2){
  return (num1 > num2)? num1-num2 : num2-num1
}
// this function is for checking the oders in bag and card page validation for added items
function checkNumberOfItemForAdditionalItem(){
  if($("#cus_email").val() != undefined && $.cookie('plan_name')){
    if(window.subs == '' || window.subs == undefined){
      var customer =  GetCustomer($("#cus_email").val());
      window.customer = customer;
      subs = customer.data[0].subscriptions;
    }
    var no_of_membership_clothes = 0;
    var no_of_membership_accessories = 0;
    var membership_products_in_cart = $(".membership_items_table .item_tags");
    for (var i = 0; i < membership_products_in_cart.length; i++) {
      if($(membership_products_in_cart[i]).val().toLowerCase().includes("clothing")){
        no_of_membership_clothes++;
      }

      if($(membership_products_in_cart[i]).val().toLowerCase().includes("accessor")){
        no_of_membership_accessories++;
      }
    }

    var orderLimitClothing = ALLOWED_PRODUCTS[subs.data[0].plan.id]["clothing"];
    var orderLimitAccessories = ALLOWED_PRODUCTS[subs.data[0].plan.id]["accessories"];
    if($('.tagstolog').text().indexOf('AdditionalItem') > -1 && $('.tagstolog').text().indexOf('CurrentlyBorrowing') == -1){
      var AdditionalItemCount = parseInt($('.AdditionalItem').text().match(/\d+/)[0])
      var count = AdditionalItemCount;
      for(i=0;i<count;i++){
        if(orderLimitClothing < no_of_membership_clothes && AdditionalItemCount > 0){
          orderLimitClothing++
          AdditionalItemCount--
        }else{
          break;
        }
      }
      var orderLimitClothing = ALLOWED_PRODUCTS[subs.data[0].plan.id]["clothing"];
      var orderLimitAccessories = ALLOWED_PRODUCTS[subs.data[0].plan.id]["accessories"];
      if($('.tagstolog').text().indexOf('AdditionalItem') > -1 && $('.tagstolog').text().indexOf('CurrentlyBorrowing') == -1){
        var AdditionalItemCount = parseInt($('.AdditionalItem').text().match(/\d+/)[0])
        var count = AdditionalItemCount;
        for(i=0;i<count;i++){
          if(orderLimitClothing < no_of_membership_clothes && AdditionalItemCount > 0){
            orderLimitClothing++
            AdditionalItemCount--
          }else{
            break;
          }
        }
        for(i=0;i<count;i++){
          if(orderLimitAccessories < no_of_membership_accessories && AdditionalItemCount > 0){
            orderLimitAccessories++
            AdditionalItemCount--
          }else{
            break;
          }
        }
        if(AdditionalItemCount > 0){
          var item  = 'item';
          if(AdditionalItemCount > 1){
            item = 'items';
          }
          $('.additionalItemMsg').html("You have "+AdditionalItemCount+" more free additional bonus "+item+" you can add! <br> If you don't use it on this order, you can use it on your next order :)").css('display','inline-block'); 
        }
      }
    }else if ($('.tagstolog').text().indexOf('upgradeItems') > -1 && $('.upgradeItems').length > 0){
      console.log(' in added items')
      var AdditionalItemCount = parseInt($('.upgradeItems').text().match(/\d+/)[0]);
      var count = AdditionalItemCount;
      var clothing = 0;
      var accessory = 0;
      for(i=0;i<AdditionalItemCount;i++){
        if(count > 0){
          count--
          accessory++
          count--
          clothing++
        }
      }
      $('.additionalItemMsg').text("You are able to check out "+clothing+" clothing item and "+accessory+" accessory.").css('display','inline-block');
    }else if ($('.tagstolog').text().indexOf('CurrentlyBorrowing') > -1 && $('.itemsAdded').length > 0){
      console.log(' in added items')
      var AdditionalItemCount = parseInt($('.itemsAdded').text().match(/\d+/)[0]);
      var item  = 'item';
        if(AdditionalItemCount == 2){
          item = 'items';
        }
      $('.additionalItemMsg').text("You are able to check out "+AdditionalItemCount+" "+item+".").css('display','inline-block');
    }
  }
}
function CheckCustomerPlan(cart_items) {
  $("#membership_items_error").hide();
  if($('.tagstolog').text().indexOf('CurrentlyBorrowing') > -1 && $('.upgradeItems').length > 0){
    var AdditionalItemCount = parseInt($('.upgradeItems').text().match(/\d+/)[0]);
     var count = AdditionalItemCount;
    var clothing = 0;
    var accessory = 0;
    for(i=0;i<AdditionalItemCount;i++){
      if(count > 0){
        count--
        accessory++
        count--
        clothing++
      }
    }
    var currentClothing = $(".membership_items_table").find("input.item_tags[value*='Clothing']").length;
    var currentAccessori = $(".membership_items_table").find("input.item_tags[value*='accessor']").length;

    if(currentClothing > clothing || currentAccessori > accessory){
      $('.additionalItemMsg').text("Sorry! You are only able to check out "+clothing+" clothing item and "+accessory+" accessory at this time!").css({"display": "inline-block", "color": "red"});
       proceed_to_checkout_loading_img();
       return;
    }else{
      window.location.href = STORE_URL + "/pages/checkout";
      return;
    }
  }else if ($('.tagstolog').text().indexOf('CurrentlyBorrowing') > -1 && $('.itemsAdded').length > 0){
    var AdditionalItemCount = parseInt($('.itemsAdded').text().match(/\d+/)[0]);
    var count = 'item';
    if(AdditionalItemCount == 2)
    count = 'items';
    if($(".membership_items_table .item_tags").length > AdditionalItemCount){
      $('.additionalItemMsg').text("Sorry! You are only able to check out "+AdditionalItemCount+" "+count+" at this time!").css({"display": "inline-block", "color": "red"});
       proceed_to_checkout_loading_img();
       return;
    }else{
      window.location.href = STORE_URL + "/pages/checkout";
      return;
    }
  }
  if($(".membership_items_table .item_tags").length > 0 && check_customer_tags_for_FP()) {
    proceed_to_checkout_loading_img();
    return;
  }

  if(!stillavailable()) {
    proceed_to_checkout_loading_img();
    return;
  }

  if($(".membership_items_table .item_tags").length == 0) {
    if(stillavailable()) {
      window.location.href = STORE_URL + "/pages/checkout";
    }
    proceed_to_checkout_loading_img();
    return;
  }

  $(".too_many_items_error").text("");
  var email = $("#cus_email").val();

  if(email == "" || email == null || $('#signin-status') == "no") {
     window.location.href = STORE_URL + "pages/fashionpass-how-it-works#plans_and_pricing";
    //window.location.href = STORE_URL + "/pages/frontpage?view=plans";
  }
  else {
    var customer = GetCustomer(email);
    if(customer != null && customer.data.length > 0) {
      var subs = customer.data[0].subscriptions

      if(subs.data.length == 0) {
        // Customer Subscription not found
        if($(".membership_items_table .item_tags").length > 0) {
          $("#membership_items_error").show();
          proceed_to_checkout_loading_img();
          return;
        }
        window.location.href = "/pages/checkout";
        proceed_to_checkout_loading_img();
        return;
      }
      else {
        debugger
        // Customer is Subscribed to some plan
        var total_products_in_cart        =  $(".item_tags");
        var membership_products_in_cart   =  $(".membership_items_table .item_tags");
        var total_no_of_accessories       =  0;
        var total_no_of_clothes           =  0;
        var no_of_membership_clothes      =  0;
        var no_of_membership_accessories  =  0;
        cookieSubcriptionPlanId = $.cookie('plan_id');
        if(cookieSubcriptionPlanId != subs.data[0].plan.id){
          var customer = GetCustomer(email);
          if(customer != null && customer.data.length > 0) {
            var customer_subscription  = customer.data[0].subscriptions.data[0].plan.id;
            var plan_name  = customer.data[0].subscriptions.data[0].plan.name;
          }
          else{
            var customer_subscription         =  subs.data[0].plan.id;
            var plan_name                     =  subs.data[0].plan.name;
          }
        }
        else{
          var customer_subscription         =  subs.data[0].plan.id;
          var plan_name                     =  subs.data[0].plan.name;
        }

        var page_redirection              =  true;

        if(plan_name == "Gold") {
          plan_name = "Socialite";
        }
        else if(plan_name == "Platinum") {
          plan_name = "Trendsetter";
        }
        else if(plan_name == "Wanderlust") {
          plan_name = "Wanderlust";
        }

        if(total_products_in_cart.length > 0)
        { 
          for (var i = 0; i < membership_products_in_cart.length; i++) 
          {
            if($(membership_products_in_cart[i]).val().toLowerCase().includes("clothing"))
            {
              no_of_membership_clothes++;
            }

            if($(membership_products_in_cart[i]).val().toLowerCase().includes("accessor"))
            {
              no_of_membership_accessories++;
            }
          }

          for (var i = 0; i < total_products_in_cart.length; i++) 
          {
            if($(total_products_in_cart[i]).val().toLowerCase().includes("clothing"))
            {
              total_no_of_clothes++;
            }

            if($(total_products_in_cart[i]).val().toLowerCase().includes("accessor"))
            {
              total_no_of_accessories++;
            }
          }
        }
        if(cart_items.length != membership_products_in_cart.length){
           var totaldiff = Math.abs( cart_items.length  - membership_products_in_cart.length );
           $(".too_many_items_error").text("Oops! You have "+totaldiff+" too many FashionPass clothing items in your box!");
              $(".too_many_items_error").show();

              var jump = ('.too_many_items_error');
              var new_position = $(jump).offset();
              $('html, body').stop().animate({ scrollTop: new_position.top - 160 }, 500);
              
              product_limit_validation_Cart(customer_subscription);
              items_limit_exceeded = true;
              proceed_to_checkout_loading_img();
              return;
        }
        if(total_no_of_clothes || total_no_of_accessories ) {

          var items_limit_exceeded = false;
          var AdditionalItemCounts = 0;
          var tooManyCloths = 0;
          var tooManyAccessories = 0; 
          
          if(nowAllowCloths == 0){
             nowAllowCloths= ALLOWED_PRODUCTS[customer_subscription]["clothing"];
          }

          if(nowAllowAccessories == 0){
            nowAllowAccessories = ALLOWED_PRODUCTS[customer_subscription]["accessories"];
          }
          
          var allow_clothing = ALLOWED_PRODUCTS[customer_subscription]["clothing"]
          var allow_accessories = ALLOWED_PRODUCTS[customer_subscription]["accessories"]
          var Total = ALLOWED_PRODUCTS[customer_subscription]["clothing"] + ALLOWED_PRODUCTS[customer_subscription]["accessories"];
          if($('.tagstolog').text().indexOf('AdditionalItem') > -1 && $('.tagstolog').text().indexOf('CurrentlyBorrowing') == -1){
            var obj = addingItemsToPakageCount('.AdditionalItem',ALLOWED_PRODUCTS[customer_subscription]["clothing"],total_no_of_clothes,ALLOWED_PRODUCTS[customer_subscription]["accessories"],no_of_membership_accessories);
            allow_clothing = obj.allowClothing;  
            allow_accessories = obj.allowAccessories;
            AdditionalItemCounts = parseInt($('.AdditionalItem').text().match(/\d+/)[0]);
            if(total_no_of_clothes > 0){  
                var tooManycheckCloths = Math.abs( nowAllowCloths - total_no_of_clothes );
                tooManyCloths = tooManycheckCloths - AdditionalItemCounts;
                AdditionalItemCounts = Math.abs(tooManyCloths);
              }

              if(total_no_of_accessories > 0){
                var tooManycheckAccessories = Math.abs( nowAllowAccessories - total_no_of_accessories );
                tooManyAccessories = Math.abs(tooManycheckAccessories-AdditionalItemCounts);
              }
              
          }else{
              tooManyCloths = Math.abs( nowAllowCloths - total_no_of_clothes );
              tooManyAccessories = Math.abs( nowAllowAccessories - total_no_of_accessories );
          }
            if(allow_clothing < no_of_membership_clothes) {
              $(".too_many_items_error").text("Oops! You have "+Math.abs(tooManyCloths)+" too many FashionPass clothing items in your box!");
              $(".too_many_items_error").show();

              var jump = ('.too_many_items_error');
              var new_position = $(jump).offset();
              $('html, body').stop().animate({ scrollTop: new_position.top - 160 }, 500);
              
              product_limit_validation_Cart(customer_subscription);
              items_limit_exceeded = true;
              proceed_to_checkout_loading_img();
              return;
            }

            if(allow_accessories < no_of_membership_accessories) {
              $(".too_many_items_error").text("Oops! You have "+Math.abs(tooManyAccessories)+" too many FashionPass accessory items in your box!");
              $(".too_many_items_error").show();

              var jump = ('.too_many_items_error');
              var new_position = $(jump).offset();
              $('html, body').stop().animate({ scrollTop: new_position.top - 160 }, 500);

              product_limit_validation_Cart(customer_subscription);
              items_limit_exceeded = true;
              proceed_to_checkout_loading_img();
              return;
            }
          if (items_limit_exceeded == false)
          {            
            if ((allow_clothing > no_of_membership_clothes) && (allow_accessories == no_of_membership_accessories))
            {
              var less_clothing_items_count = (ALLOWED_PRODUCTS[customer_subscription]["clothing"] - no_of_membership_clothes);
              var clothing_grammar = null;

              if (less_clothing_items_count == 1)
              {
                clothing_grammar = "With the " + plan_name + " plan you are allowed to get <span style='color:#f69295'>" + less_clothing_items_count + " more clothing item</span>.<br> Are you sure you want to checkout without an extra free clothing item?";
              }
              else if (less_clothing_items_count > 1)
              {
                clothing_grammar = "With the " + plan_name + " plan you are allowed to get <span style='color:#f69295'>" + less_clothing_items_count + " more clothing items</span>.<br> Are you sure you want to checkout without extra free clothing items?";
              }

              // Only clothing items are less. Accessories are taken as per user plan
              $(".less_item_message").html(clothing_grammar);
              $("a#less_clothing_items_in_cart_trigger").click();
              proceed_to_checkout_loading_img();
            }
            else if ((allow_clothing == no_of_membership_clothes) && (allow_accessories > no_of_membership_accessories))
            {
              // Only Accessories are less. Clothing are taken as per user plan
              var less_accessory_items_count = (ALLOWED_PRODUCTS[customer_subscription]["accessories"] - no_of_membership_accessories);
              var accessory_grammar = null;

              if (less_accessory_items_count == 1)
              {
                accessory_grammar = "With the " + plan_name + " plan you are allowed to get <span style='color:#f69295'>" + less_accessory_items_count + " more accessory item</span>. <br> Are you sure you want to checkout without an extra free accessory item?";
              }
              else if (less_accessory_items_count > 1)
              {
                accessory_grammar = "With the " + plan_name + " plan you are allowed to get <span style='color:#f69295'>" + less_accessory_items_count + " more accessory items</span>. <br> Are you sure you want to checkout without extra free accessory items?";
              }

              $(".less_item_message").html(accessory_grammar);
              $("a#less_accessory_items_in_cart_trigger").click();
              proceed_to_checkout_loading_img();
            }
            else if ((allow_clothing > no_of_membership_clothes) && (allow_accessories > no_of_membership_accessories))
            {
              var less_clothing_items_count = (ALLOWED_PRODUCTS[customer_subscription]["clothing"] - no_of_membership_clothes);
              var clothing_grammar = null;
              if (less_clothing_items_count == 1)
              {
                clothing_grammar = "With the " + plan_name + " plan you are allowed to get <span style='color:#f69295'>" + less_clothing_items_count + " more clothing item</span>. <br> Are you sure you want to checkout without an extra free clothing item?";
              }
              else if (less_clothing_items_count > 1)
              {
                clothing_grammar = "With the " + plan_name + " plan you are allowed to get <span style='color:#f69295'>" + less_clothing_items_count + " more clothing items</span>. <br> Are you sure you want to checkout without extra free clothing items?";
              }
              $(".less_item_message").html(clothing_grammar);
              $("a#less_clothing_items_in_cart_trigger").click();
              proceed_to_checkout_loading_img();
            }
            else
            {
              if(stillavailable()) {
                window.location.href = STORE_URL + "/pages/checkout";
              }
            }
          }
        }
      }
    }
    else if ($(".store_items").length > 0){
      // Customer not found in stripe but buying store items using shopify account
      if($(".membership_items_table .item_tags").length > 0)
        {
          $("#membership_items_error").show();
          proceed_to_checkout_loading_img();
          return;
        }
      
      if(stillavailable()) {
        window.location.href = STORE_URL + "/pages/checkout";
      }
    }
    else {
      // Customer not found in stripe
       if($(".membership_items_table .item_tags").length > 0)
        {
          $("#membership_items_error").show();
          proceed_to_checkout_loading_img();
          return;
        }
      window.location.href = "/account?view=plans";
    }
  }
}

function show_customer_plan_Cart() {
  var customer = $("#cus_email").val();
  customer = GetCustomer(customer);

  if (customer != null && customer != undefined  && customer.data[0] != null && customer.data[0].subscriptions != undefined) {

    var customer_subscription = GetSubscriptions(customer.data[0].id);

    if (customer_subscription != undefined && customer_subscription.data.length) {
      customer_subscription = customer_subscription.data[0].plan.id;

      if (customer_subscription == "hauteandborrowed_gold")
      {
        $("#empty_box_show_curr_plan span").text("Current plan: Socialite");
        $(".current_plan_Cart").text("Current plan: Socialite");
        $(".current_plan_upadte_Cart a").html("Upgrade to Trendsetter");
        $('.current_plan_upadte_Cart a').attr('href','/account?view=checkout&amp;plan_id=hauteandborrowed_Platinum');
        $('.current_plan_upadte_Cart a').attr('id','hauteandborrowed_Platinum');
      }
      else if (customer_subscription == "hauteandborrowed_Platinum")
      {
        $("#empty_box_show_curr_plan span").text("Current plan: Trendsetter");
        $(".current_plan_Cart").text("Current plan: Trendsetter");
        $(".current_plan_upadte_Cart a").html("Upgrade to Wanderlust");
        $('.current_plan_upadte_Cart a').attr('href','/account?view=checkout&amp;plan_id=hauteandborrowed_Wanderlust');
        $('.current_plan_upadte_Cart a').attr('id','hauteandborrowed_Wanderlust');
      }
      else if (customer_subscription == "hauteandborrowed_Wanderlust")
      {
        $("#empty_box_show_curr_plan span").text("Current plan: Wanderlust");
        $(".current_plan_Cart").text("Current plan: Wanderlust");
        $(".current_plan_upadte_Cart").text("");
      }
      else
      {
        $(".current_plan_Cart").text("");
      }

      if (customer_subscription == "hauteandborrowed_gold")
      {
        $(".current_plan_limits_Cart").text(ALLOWED_PRODUCTS[customer_subscription]["clothing"] + " clothing items + " + ALLOWED_PRODUCTS[customer_subscription]["accessories"] + " accessory");
      }
      else
      {
        $(".current_plan_limits_Cart").text(ALLOWED_PRODUCTS[customer_subscription]["clothing"] + " clothing items + " + ALLOWED_PRODUCTS[customer_subscription]["accessories"] + " accessories");
      }

      if($('.tagstolog').text().indexOf('AdditionalItem') > -1 && $('.tagstolog').text().indexOf('CurrentlyBorrowing') == -1){
           var AdditionalItemsCount = parseInt($('.AdditionalItem').text().match(/\d+/)[0]);
            if(AdditionalItemsCount > 0){
                var itemText  = 'item';
                if(AdditionalItemsCount > 1){
                  itemText = 'items';
                }
                $(".additional_item_number").text("+ "+AdditionalItemsCount+" additional "+itemText).show();
            }
      }
    } 
    else {
      $(".current_plan_Cart").text("");
      $(".current_plan_limits_Cart").text("");
    }
  }
}
 
function product_limit_validation_Cart(customer_subscription) {
 
  if (customer_subscription == "hauteandborrowed_gold")
  {
    $(".upgrade_plan_to_trendsetter_Cart, .upgrade_plan_to_wanderlust_Cart, .remove_membership_items, .remove_membership_or").show();
  }
  else if (customer_subscription == "hauteandborrowed_Platinum")
  {
    $(".upgrade_plan_to_wanderlust_Cart, .remove_membership_items, .remove_membership_or").show();
  }
}

function stillavailable() {
  $('.Sold_out_items_error').hide();
  var single_product = null;
  var product_availability = true;
  var cart = get_cart_Shopify();

  if (cart != null && cart.errors == undefined) {
    // Timeout and error conditions handled
    var index = 0;
    for(var i = 0; i < cart.items.length; i++) {
      var response = checkProductavailabilty(cart.items[i].variant_id)
      if (response != true) {
        index = i;
        product_availability = false;
        break;
      }
    }

    if (product_availability == false) {
      $('.Sold_out_items_error').show();
      $('#Sold_out_items').text(cart.items[index].title );
      return product_availability;
    }
    return product_availability;
  }
  else {
    $(".proceed-to-checkout").val("Something went wrong");
  }
}

function remove_fp_text()
{
  if($(".fp_items_length").val() > 0)
  {
    $(".fp_text_remove").show();
  }
}

$( window ).resize(function() {
  if($( window ).width() < 767){
    $(".proceed-to-checkout").hide();
    $(".bottom_btn").show();
  }

});

$('document').ready(function() {
 if($( window ).width() < 767){
    $(".proceed-to-checkout").hide();
    $(".bottom_btn").show();
  }else{
    $(".proceed-to-checkout").show();
  }
  ////second polyfill 
   if (!String.prototype.includes || String.prototype.includes == undefined) {
     String.prototype.includes = function() {
         'use strict';
         return String.prototype.indexOf.apply(this, arguments) !== -1;
     };
   }
  $("a#less_clothing_items_in_cart_trigger").fancybox({
    'hideOnContentClick': true
  });

  $("a#less_accessory_items_in_cart_trigger").fancybox({
    'hideOnContentClick': true
  });


  $("#less_clothing_items_in_cart_popup .yes_checkout").click(function(){
    less_clothing_items_popup();
  });

  $("#less_accessory_items_in_cart_popup .yes_checkout").click(function() {
    window.location.href = STORE_URL + "/pages/checkout";
  });

  $(".no_let_browse").click(function() {
    $.fancybox.close();
  });
  
  $(".proceed-to-checkout").on("click", function (e) {
    debugger;
    // if($('.tagstolog').text().indexOf('CurrentlyBorrowing') == -1){
    //   $('.coronaPromobarAlert').click();
    //   return
    // }
   proceedToCheckout();
  });
  remove_fp_text(); 
  //mohiwork
  show_customer_plan_Cart();

  //code for fashionpass checkout retail tags by banjoo
  var product_ids = [];
  $('.product_id_').each(function() {
      if($(this).val() != "")
         product_ids.push($(this).val());
  });
 var new_product_ids=product_ids.join(',');
 $.ajax({
        type: 'GET',
        url: DBINFOURL+'/Product_information/getRetailByProductIdNew?productid='+new_product_ids, 
        async: true
      }).done( function(response){
					var products=[];
					response=response.slice(',', -1);
					response=response.split(',');
					$.each(response, function(i, item) {
						products_obj=response[i].split('-');
						product_ids=products_obj[0];
						product_price=products_obj[1];
						if(product_price!=='Null'){
							$('.retail_price[data-productid="'+product_ids+'"]').text(' Retail: $'+product_price);
						}					
					})
		  

      });
 

 

  
});